module.exports = __webpack_public_path__ + "c50e03997229d2ae16222a82f9d2e3be.svg";